// 2027 calendar landing page (templates/product.calendar.json).
// One store, one reducer; every [data-cal-*] element is a view of state.
// Page data comes from #calendar-data (snippets/calendar-page.liquid).
// JS sets data attributes and text, never Tailwind classes: styling for them lives in calendar.css.
(function () {
  "use strict";

  var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var FORMS = ["hero", "cta"];
  var LAST_PAGE = 12;


  function clampQty(value, current, max) {
    var n = Math.round(Number(value));
    if (!isFinite(n)) return current;
    return Math.min(max, Math.max(1, n));
  }

  function splitMs(ms) {
    var t = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
  }

  function initialState(now, inCart, cartCount) {
    var submits = {};
    FORMS.forEach(function (f) { submits[f] = { kind: "idle" }; });
    return { now: now, qty: 1, soldOutByServer: false, inCart: inCart, cartCount: cartCount, submits: submits };
  }

  // soldout beats closed beats open
  function deriveSale(data, s) {
    if (!data.available || s.soldOutByServer) return { kind: "soldout" };
    var ms = data.closesAt - s.now;
    if (ms <= 0) return { kind: "closed" };
    return { kind: "open", left: splitMs(ms) };
  }

  function withSubmit(s, form, submit) {
    var submits = Object.assign({}, s.submits);
    submits[form] = submit;
    return Object.assign({}, s, { submits: submits });
  }

  function reduce(data, s, a) {
    switch (a.type) {
      case "tick":
        return a.now === s.now ? s : Object.assign({}, s, { now: a.now });
      case "setQty": {
        var qty = clampQty(a.qty, s.qty, data.maxQty);
        return qty === s.qty ? s : Object.assign({}, s, { qty: qty });
      }
      case "submit":
        if (!s.submits[a.form] || s.submits[a.form].kind === "pending") return s;
        if (deriveSale(data, s).kind !== "open") return s;
        return withSubmit(s, a.form, { kind: "pending" });
      case "submitDone":
        return Object.assign(withSubmit(s, a.form, { kind: "idle" }), { inCart: true, cartCount: a.cartCount });
      case "setCart":
        if (a.inCart === s.inCart && a.cartCount === s.cartCount) return s;
        return Object.assign({}, s, { inCart: a.inCart, cartCount: a.cartCount });
      case "submitFailed": {
        var next = withSubmit(s, a.form, { kind: "error", message: a.message });
        return a.soldOut ? Object.assign(next, { soldOutByServer: true }) : next;
      }
      default:
        return s;
    }
  }

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function plural(n, word) { return n + " " + word + (n === 1 ? "" : "s"); }

  var SR_LABELS = { shipping: "Free shipping ends in", preorder: "Preorders close in" };
  // Free shipping lasts at most 48 hours, so it counts in hours with no days tile.
  var HOURS_ONLY = { shipping: true };

  function timersOf(data) {
    return data.timers || [{ id: "preorder", endsAt: data.closesAt }];
  }

  // Worked out from the start of the minute, so the words change at most once a minute.
  function srText(data, s) {
    var now = Math.floor(s.now / 60000) * 60000;
    var sale = deriveSale(data, Object.assign({}, s, { now: now }));
    if (sale.kind === "closed") return "Preorders have closed.";
    if (sale.kind === "soldout") return "Sold out.";
    var soonest = timersOf(data).filter(function (t) { return t.endsAt > now; })[0];
    if (!soonest) return "";
    var l = splitMs(soonest.endsAt - now);
    if (HOURS_ONLY[soonest.id]) return SR_LABELS[soonest.id] + " " + plural(l.d * 24 + l.h, "hour") + " and " + plural(l.m, "minute") + ".";
    return SR_LABELS[soonest.id] + " " + plural(l.d, "day") + ", " + plural(l.h, "hour") + " and " + plural(l.m, "minute") + ".";
  }

  function deriveView(data, s) {
    var sale = deriveSale(data, s);
    return {
      sale: sale,
      srMinute: srText(data, s),
      totalCents: s.qty * data.priceCents,
      timers: timersOf(data).map(function (t) {
        var running = sale.kind === "open" && t.endsAt > s.now;
        var l = splitMs(t.endsAt - s.now);
        return {
          id: t.id,
          running: running,
          cd: !running ? null : HOURS_ONLY[t.id] ? {
            h: pad(l.d * 24 + l.h), m: pad(l.m), s: pad(l.s),
            compact: pad(l.d * 24 + l.h) + "h " + pad(l.m) + "m " + pad(l.s) + "s"
          } : {
            d: String(l.d), h: pad(l.h), m: pad(l.m), s: pad(l.s),
            compact: l.d + "d " + pad(l.h) + "h " + pad(l.m) + "m " + pad(l.s) + "s"
          }
        };
      })
    };
  }

  // 42 cells (six weeks, Sunday first); null for days outside the month.
  function monthGrid(year, month) {
    var first = new Date(year, month, 1).getDay();
    var days = new Date(year, month + 1, 0).getDate();
    var cells = [];
    var i;
    for (i = 0; i < first; i++) cells.push(null);
    for (i = 1; i <= days; i++) cells.push(i);
    while (cells.length < 42) cells.push(null);
    return cells;
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  if (typeof module === "object" && module.exports) {
    module.exports = { clampQty: clampQty, splitMs: splitMs, initialState: initialState, deriveSale: deriveSale, reduce: reduce, deriveView: deriveView, monthGrid: monthGrid, formatMoney: formatMoney };
    return;
  }


  function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
  function setAttr(el, name, value) {
    if (value === null) { if (el.hasAttribute(name)) el.removeAttribute(name); }
    else if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function setProp(el, prop, value) { if (el[prop] !== value) el[prop] = value; }
  function all(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === "text") node.textContent = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function readPageData() {
    var node = document.getElementById("calendar-data");
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      if (!data.variantId || !Array.isArray(data.pages) || data.pages.length !== 13) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function createStore(data, state, onChange) {
    return {
      get: function () { return state; },
      dispatch: function (action) {
        var next = reduce(data, state, action);
        if (next !== state) {
          state = next;
          onChange(state);
        }
      }
    };
  }

  // Split-flap countdown tiles. The [data-cal-cd] number always holds the current value; while it flips,
  // .cal-flap halves in the same grid cell cover it: the old bottom half, the old top half folding down,
  // then the new bottom half folding down onto it.
  function createFlaps(reducedMotion) {
    var active = new WeakMap();
    var PERSPECTIVE = "perspective(8em) ";

    function settle(num) {
      var flip = active.get(num);
      if (!flip) return;
      active.delete(num);
      flip.anims.forEach(function (a) { a.cancel(); });
      flip.parts.forEach(function (p) { p.remove(); });
    }

    function half(text, side) { return el("span", { class: "cal-flap cal-flap--" + side, text: text }); }

    return function (num, text) {
      var old = num.textContent;
      if (old === text) return;
      settle(num);
      var still = reducedMotion || document.hidden || typeof num.animate !== "function" || !num.parentNode.classList.contains("cal-tile") || !num.offsetParent;
      num.textContent = text;
      if (still) return;
      var under = half(old, "bottom");
      var fold = half(old, "top");
      var land = half(text, "bottom");
      num.after(under, fold, land);
      var flip = {
        parts: [under, fold, land],
        anims: [
          fold.animate([
            { transform: PERSPECTIVE + "rotateX(0deg)", filter: "brightness(1)" },
            { transform: PERSPECTIVE + "rotateX(-90deg)", filter: "brightness(0.82)" }
          ], { duration: 150, easing: "ease-in", fill: "forwards" }),
          land.animate([
            { transform: PERSPECTIVE + "rotateX(90deg)", filter: "brightness(0.82)" },
            { transform: PERSPECTIVE + "rotateX(0deg)", filter: "brightness(1)" }
          ], { duration: 150, delay: 150, easing: "ease-out", fill: "backwards" })
        ]
      };
      active.set(num, flip);
      flip.anims[1].onfinish = function () { if (active.get(num) === flip) settle(num); };
    };
  }

  function render(root, data, s, flap) {
    var v = deriveView(data, s);
    var setCount = flap || setText;
    var open = v.sale.kind === "open";
    setAttr(root.documentElement, "data-cal-sale", v.sale.kind);

    v.timers.forEach(function (t) {
      all(root, '[data-cal-timer="' + t.id + '"]').forEach(function (wrap) {
        setAttr(wrap, "data-expired", t.running ? null : "");
        if (t.cd) all(wrap, "[data-cal-cd]").forEach(function (node) { setCount(node, t.cd[node.getAttribute("data-cal-cd")] || ""); });
      });
    });
    all(root, "[data-cal-cd-sr]").forEach(function (node) { setText(node, v.srMinute); });

    var total = formatMoney(v.totalCents, data.currency);
    all(root, "[data-cal-total]").forEach(function (node) { setText(node, total); });

    all(root, "[data-cal-qty]").forEach(function (input) {
      if (root.activeElement !== input) setProp(input, "value", String(s.qty));
      setProp(input, "disabled", !open);
    });
    all(root, "[data-cal-step]").forEach(function (button) { setProp(button, "disabled", !open); });

    all(root, "[data-cal-form]").forEach(function (form) {
      var submit = s.submits[form.getAttribute("data-cal-form")] || { kind: "idle" };
      var pending = submit.kind === "pending";
      var button = form.querySelector("[data-cal-submit]");
      var label = form.querySelector("[data-cal-submit-label]");
      var error = form.querySelector("[data-cal-error]");
      if (button) {
        setProp(button, "disabled", !open || pending);
        setAttr(button, "aria-busy", pending ? "true" : null);
      }
      if (label) setText(label, pending ? "Adding…" : open ? "Add to cart" : "Sold out");
      if (error) setText(error, submit.kind === "error" ? submit.message : "");
    });

    all(root, "[data-cal-view-cart]").forEach(function (link) { setProp(link, "hidden", !s.inCart); });
    all(root, "[data-cal-cart-count]").forEach(function (node) { setText(node, String(s.cartCount)); });
    all(root, "[data-cal-cart-count-sr]").forEach(function (node) { setText(node, "(" + plural(s.cartCount, "item") + ")"); });
  }

  function submitForm(store, data, form, opener) {
    var before = store.get();
    store.dispatch({ type: "submit", form: form });
    if (store.get() === before) return;

    var cart = window.themeCart;
    var request = cart && typeof cart.add === "function"
      ? cart.add(data.variantId, store.get().qty)
      : Promise.resolve({ ok: false, status: 0, message: "Unable to add item to cart. Please try again." });

    request.then(function (result) {
      if (result.ok) {
        store.dispatch({ type: "submitDone", form: form, cartCount: result.itemCount });
        cart.showAdded(opener);
      } else {
        // A 422 also covers "you can't add more"; only a sold-out message closes the sale.
        var soldOut = result.status === 422 && /sold out/i.test(result.message || "");
        store.dispatch({ type: "submitFailed", form: form, message: result.message, soldOut: soldOut });
      }
    });
  }

  function bindForms(root, store, data) {
    all(root, "[data-cal-form]").forEach(function (form) {
      var id = form.getAttribute("data-cal-form");
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var input = form.querySelector("[data-cal-qty]");
        if (input) store.dispatch({ type: "setQty", qty: input.value });
        submitForm(store, data, id, form.querySelector("[data-cal-submit]"));
      });
    });
    all(root, "[data-cal-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        store.dispatch({ type: "setQty", qty: store.get().qty + Number(button.getAttribute("data-cal-step")) });
      });
    });
    all(root, "[data-cal-qty]").forEach(function (input) {
      input.addEventListener("change", function () {
        store.dispatch({ type: "setQty", qty: input.value });
        setProp(input, "value", String(store.get().qty));
      });
    });
  }

  // A page restored from the back/forward cache may hold a stale cart, say after emptying it on /cart.
  function watchCart(store, data) {
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) return;
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (item) { return item.product_id === data.productId; });
          store.dispatch({ type: "setCart", inCart: inCart, cartCount: cart.item_count || 0 });
        })
        .catch(function () {});
    });
  }

  function startClock(store) {
    var tick = function () { store.dispatch({ type: "tick", now: Date.now() }); };
    setInterval(tick, 1000);
    document.addEventListener("visibilitychange", tick);
  }


  function createFlip(root, data, opts) {
    var stage = root.querySelector("[data-cal-stage]");
    var top = root.querySelector("[data-cal-top]");
    var bottom = root.querySelector("[data-cal-bottom]");
    var label = document.querySelector("[data-cal-flip-label]");
    var thumbs = all(document, "[data-cal-thumb]");
    var coverTop = top.firstElementChild ? top.firstElementChild.cloneNode(true) : null;
    var pages = data.pages;
    var grids = data.grids || [];
    var year = data.year;
    var nextButton = document.querySelector("[data-cal-next]");
    var prevButton = document.querySelector("[data-cal-prev]");
    var state = { shown: 0, anim: null, queued: null, touched: false };
    // Bumped by halt(); a turn's pending callbacks check it so a halted turn never lands.
    var gen = 0;
    var turning = [];

    function pageName(i) { return i === 0 ? "Cover" : MONTHS[i - 1] + " " + year; }

    function mystery() {
      return el("div", { class: "cal-mystery", "aria-hidden": "true" }, [
        el("span", { class: "cal-mystery__q", text: "?" }),
        el("span", { class: "cal-mystery__text", text: "A surprise until it’s on your wall" })
      ]);
    }

    function topContent(i) {
      if (i === 0 && coverTop) return coverTop.cloneNode(true);
      var page = pages[i];
      var photo = el("div", { class: "cal__photo" });
      if (page.kind === "photo") {
        photo.appendChild(el("img", { src: page.src, alt: page.alt }));
      } else if (page.kind === "veiled") {
        photo.appendChild(el("img", { src: page.src, alt: "", class: "cal-veiled" }));
        photo.appendChild(mystery());
      } else {
        var swatch = el("span", { class: "cal-swatch" });
        swatch.style.background = page.color;
        photo.appendChild(swatch);
        if (page.hidden) photo.appendChild(mystery());
      }
      return photo;
    }

    function bottomContent(i) {
      if (i === 0) {
        var yearGrid = el("div", { class: "cal-yg", "aria-hidden": "true" }, [
          el("div", { class: "cal-yg__title" }, [document.createTextNode(String(year)), el("small", { text: "January to December" })])
        ]);
        MONTHS.forEach(function (name, m) {
          var grid = el("div", { class: "cal-ym__grid" });
          monthGrid(year, m).forEach(function (day) { grid.appendChild(el("span", { text: day ? String(day) : "" })); });
          yearGrid.appendChild(el("div", {}, [el("div", { class: "cal-ym__name", text: name }), grid]));
        });
        return yearGrid;
      }
      var month = i - 1;
      if (grids[month]) return el("img", { class: "cal-grid-page", src: grids[month], alt: "" });
      var cells = el("div", { class: "cal-gp__grid" });
      monthGrid(year, month).forEach(function (day, n) {
        var cell = el("span", { text: day ? String(day) : "" });
        if (!day) cell.setAttribute("data-empty", "");
        else if (n % 7 === 0) cell.setAttribute("data-sunday", "");
        cells.appendChild(cell);
      });
      var dow = el("div", { class: "cal-gp__dow" });
      ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].forEach(function (d) { dow.appendChild(el("span", { text: d })); });
      return el("div", { class: "cal-gp", "aria-hidden": "true" }, [
        el("div", { class: "cal-gp__head" }, [el("span", { class: "cal-gp__month", text: MONTHS[month] }), el("span", { class: "cal-gp__year", text: String(year) })]),
        dow,
        cells
      ]);
    }

    function fill(target, node) { target.replaceChildren(node); }

    // Safari paints a fresh <img> blank until it decodes, which flashes mid-flip.
    function decoded(nodes) {
      var waits = [];
      nodes.forEach(function (node) {
        all(node, "img").forEach(function (img) { if (img.decode) waits.push(img.decode().catch(function () {})); });
      });
      if (waits.length === 0) return Promise.resolve();
      return Promise.race([Promise.all(waits), new Promise(function (r) { setTimeout(r, 250); })]);
    }

    pages.map(function (page) { return page.src; }).concat(grids).forEach(function (src) {
      if (!src) return;
      var img = new Image();
      img.src = src;
      if (img.decode) img.decode().catch(function () {});
    });

    function setUI(i) {
      setText(label, pageName(i));
      if (prevButton) setAttr(prevButton, "aria-disabled", i === 0 ? "true" : null);
      if (nextButton) setAttr(nextButton, "aria-disabled", i === LAST_PAGE ? "true" : null);
      thumbs.forEach(function (t) { setAttr(t, "aria-current", Number(t.getAttribute("data-cal-thumb")) === i ? "true" : "false"); });
    }

    function sway() {
      if (opts.reducedMotion) return;
      root.animate(
        [{ transform: "rotate(-.6deg)" }, { transform: "rotate(-1.3deg)" }, { transform: "rotate(-.25deg)" }, { transform: "rotate(-.6deg)" }],
        { duration: 900, easing: "ease-out" }
      );
    }

    var TURN = { duration: 720, easing: "cubic-bezier(.5,0,.2,1)", fill: "forwards" };
    // A dragged turn follows the finger linearly; its release plays the rest at this pace.
    var DRAG_TURN = { duration: 300, easing: "linear", fill: "forwards" };

    function go(to, dir) {
      to = Math.max(0, Math.min(LAST_PAGE, to));
      if (state.anim) { state.queued = { to: to, dir: dir }; return; }
      if (to === state.shown) return;
      var from = state.shown;
      state.shown = to;
      setUI(to);

      if (opts.reducedMotion || typeof stage.animate !== "function") {
        fill(top, topContent(to));
        fill(bottom, bottomContent(to));
        return;
      }

      state.anim = { to: to, dir: dir > 0 ? 1 : -1 };
      prepare(from, to, dir > 0).then(function (turn) {
        if (turn) animate(turn, TURN)[0].onfinish = function () { land(turn); };
      });
    }

    // Builds the turning sheet and swaps in the half it uncovers: forward, the next grid under the lifting sheet;
    // back, the previous photo above the sheet coming down. `covered` puts the old half back if a drag lets go.
    function prepare(from, to, forward) {
      var front = el("div", { class: "cal__page cal__page--bottom cal__face" }, [bottomContent(forward ? from : to), el("i", { class: "cal__shade" })]);
      var back = el("div", { class: "cal__page cal__page--top cal__face cal__face--back" }, [topContent(forward ? to : from), el("i", { class: "cal__shade" })]);
      var flip = el("div", { class: "cal__flip", "aria-hidden": "true" }, [front, back]);
      var target = forward ? bottom : top;
      var covered = target.firstElementChild;
      var revealed = forward ? bottomContent(to) : topContent(to);
      var at = gen;
      return decoded([front, back, revealed]).then(function () {
        if (at !== gen) return null;
        if (!forward) flip.style.transform = "rotateX(180deg)";
        fill(target, revealed);
        stage.appendChild(flip);
        return { flip: flip, front: front, back: back, forward: forward, to: to, target: target, covered: covered, gen: at };
      });
    }

    function animate(turn, timing) {
      var forward = turn.forward;
      var shadeFront = forward ? [0, 0.4, 0.4] : [0.4, 0.4, 0];
      var shadeBack = forward ? [0.4, 0.4, 0] : [0, 0.4, 0.4];
      var toFrames = function (list) { return list.map(function (o, n) { return { opacity: o, offset: n / 2 }; }); };
      turning = [
        turn.flip.animate(
          [{ transform: "rotateX(" + (forward ? 0 : 180) + "deg)" }, { transform: "rotateX(" + (forward ? 180 : 0) + "deg)" }],
          timing
        ),
        turn.front.lastChild.animate(toFrames(shadeFront), timing),
        turn.back.lastChild.animate(toFrames(shadeBack), timing)
      ];
      return turning;
    }

    function land(turn) {
      if (turn.gen !== gen) return;
      var settled = turn.forward ? topContent(turn.to) : bottomContent(turn.to);
      fill(turn.forward ? top : bottom, settled);
      decoded([settled]).then(function () { if (turn.gen === gen) finish(turn.flip, true); });
    }

    function finish(flip, turned) {
      flip.remove();
      state.anim = null;
      if (turned) sway();
      var queued = state.queued;
      state.queued = null;
      if (queued && queued.to !== state.shown) go(queued.to, queued.dir);
    }

    // The calendar stops at the cover and at December; pushing past either end only wobbles it.
    function step(dir) {
      state.touched = true;
      var to = state.shown + dir;
      if (to < 0 || to > LAST_PAGE) { if (!state.anim) sway(); return; }
      go(to, dir);
    }
    function next() { step(1); }
    function prev() { step(-1); }

    fill(bottom, bottomContent(0));

    // Touch: vertical drags scroll the page (touch-action: pan-y in calendar.css); a horizontal swipe flips.
    // Taps right after a scroll are the finger stopping the scroll, not a request to flip.
    // In the viewer nothing scrolls (touch-action: none): a vertical drag turns the page under the finger,
    // a horizontal swipe flips on release, and down on the cover closes it.
    var lastScroll = 0;
    var swipe = null;
    var swiped = false;
    var live = !opts.reducedMotion && typeof stage.animate === "function";

    // Called once the finger has settled on a vertical drag. mode: turn, edge (up on December), cover (down on the cover), or busy.
    function startDrag(g, dir) {
      var to = state.shown + dir;
      state.touched = true;
      g.dir = dir;
      g.to = to;
      g.span = stage.getBoundingClientRect().height * 0.6;
      g.progress = 0;
      if (state.anim) g.mode = "busy";
      else if (to > LAST_PAGE) g.mode = "edge";
      else if (to < 0) g.mode = "cover";
      else {
        g.mode = "turn";
        state.anim = { to: to, dir: dir };
        prepare(state.shown, to, dir > 0).then(function (turn) {
          if (!turn) return;
          g.turn = turn;
          g.anims = animate(turn, DRAG_TURN);
          g.anims.forEach(function (a) { a.pause(); });
          seek(g);
          if (g.outcome) release(g);
        });
      }
    }

    function dragTo(g, y, t) {
      var dist = g.dir > 0 ? g.y - y : y - g.y;
      g.samples.push({ t: t, y: y });
      while (g.samples.length > 2 && t - g.samples[0].t > 100) g.samples.shift();
      if (g.mode === "turn") {
        g.progress = Math.max(0, Math.min(1, dist / g.span));
        if (g.anims) seek(g);
      } else if (g.mode === "edge") {
        bottom.style.transformOrigin = "50% 0";
        bottom.style.transform = "rotateX(" + 6 * (1 - Math.exp(-Math.max(0, dist) / 80)) + "deg)";
      }
      return dist;
    }

    function seek(g) {
      g.anims.forEach(function (a) { a.currentTime = g.progress * DRAG_TURN.duration; });
    }

    function speedOf(g) {
      var first = g.samples[0];
      var last = g.samples[g.samples.length - 1];
      var dt = last.t - first.t;
      if (dt <= 0) return 0;
      return (g.dir > 0 ? first.y - last.y : last.y - first.y) / dt;
    }

    function endDrag(g, commit) {
      if (g.mode === "turn") {
        g.outcome = commit ? "commit" : "cancel";
        if (commit) {
          state.shown = g.to;
          setUI(state.shown);
        }
        if (g.anims) release(g);
      } else if (g.mode === "edge") {
        var lifted = bottom.style.transform;
        bottom.style.transform = "";
        bottom.style.transformOrigin = "";
        bottom.animate(
          [{ transform: lifted, transformOrigin: "50% 0" }, { transform: "rotateX(0deg)", transformOrigin: "50% 0" }],
          { duration: 350, easing: "cubic-bezier(.3,1.5,.5,1)" }
        );
      }
    }

    // Plays the rest of the turn from where the finger left it, or back to where it started.
    function release(g) {
      var commit = g.outcome === "commit";
      var turn = g.turn;
      var at = g.anims[0].currentTime;
      g.anims[0].onfinish = commit
        ? function () { land(turn); }
        : function () { if (turn.gen === gen) { fill(turn.target, turn.covered); finish(turn.flip, false); } };
      // The drag runs a 300ms timeline so it can follow the finger; played at that pace, a quick flick
      // would finish a whole turn in a few frames. Stretch the rest to its share of a 650ms turn.
      var left = commit ? 1 - at / DRAG_TURN.duration : at / DRAG_TURN.duration;
      var rate = (left * DRAG_TURN.duration) / Math.max(320, left * 650);
      g.anims.forEach(function (a) {
        a.playbackRate = commit ? rate : -rate;
        // play() at either end would rewind and run the whole turn again.
        if (at === (commit ? DRAG_TURN.duration : 0)) a.finish(); else a.play();
      });
    }

    window.addEventListener("scroll", function () { lastScroll = Date.now(); }, { passive: true });
    root.addEventListener("pointerdown", function (e) {
      if (opts.busy()) { swipe = null; swiped = true; return; }
      if (swipe && swipe.axis) return;
      swiped = false;
      if (e.pointerType === "mouse") { swipe = null; return; }
      swipe = { id: e.pointerId, x: e.clientX, y: e.clientY, axis: null, samples: [{ t: e.timeStamp, y: e.clientY }] };
      if (opts.viewing()) {
        try { root.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    root.addEventListener("pointermove", function (e) {
      var g = swipe;
      if (!g || e.pointerId !== g.id || !live || !opts.viewing()) return;
      if (!g.axis) {
        var dx = e.clientX - g.x;
        var dy = e.clientY - g.y;
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        g.axis = Math.abs(dy) > Math.abs(dx) ? "y" : "x";
        if (g.axis === "y") startDrag(g, dy < 0 ? 1 : -1);
      }
      if (g.axis === "y") dragTo(g, e.clientY, e.timeStamp);
    });
    function cancelSwipe(e) {
      var g = swipe;
      if (!g || e.pointerId !== g.id) return;
      swipe = null;
      if (g.axis === "y") endDrag(g, false);
    }
    root.addEventListener("pointercancel", cancelSwipe);
    root.addEventListener("lostpointercapture", cancelSwipe);
    root.addEventListener("pointerup", function (e) {
      var g = swipe;
      if (!g || e.pointerId !== g.id) return;
      swipe = null;
      var dx = e.clientX - g.x;
      var dy = e.clientY - g.y;
      if (g.axis === "y") {
        swiped = true;
        var dist = dragTo(g, e.clientY, e.timeStamp);
        if (g.mode === "cover" && dist > 40) opts.onCoverSwipeDown();
        endDrag(g, g.progress > 0.35 || (g.progress > 0.05 && speedOf(g) > 0.5));
      } else if (opts.viewing()) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) <= 40) return;
        swiped = true;
        if (g.axis !== "x" && Math.abs(dy) > Math.abs(dx)) {
          if (dy < 0) next();
          else if (state.shown === 0) opts.onCoverSwipeDown();
          else prev();
        } else if (dx < 0) next(); else prev();
      } else if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        swiped = true;
        if (dx < 0) next(); else prev();
      }
    });
    // Inline, the photo half turns back a page and the month half turns forward, like lifting either sheet.
    // In the phone viewer any tap turns forward; swipes go both ways there.
    root.addEventListener("click", function (e) {
      if (swiped) { swiped = false; return; }
      if (opts.busy() || Date.now() - lastScroll < 350) return;
      var box = stage.getBoundingClientRect();
      var onPhoto = e.detail > 0 && e.clientY < box.top + box.height / 2;
      if (onPhoto && !opts.viewing()) prev(); else next();
    });
    root.addEventListener("keydown", function (e) {
      if (opts.busy()) return;
      if (e.key === "Enter" || e.key === " " || e.key === "ArrowRight") { e.preventDefault(); next(); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); prev(); }
    });
    setUI(0);
    if (nextButton) nextButton.addEventListener("click", next);
    if (prevButton) prevButton.addEventListener("click", prev);
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var i = Number(t.getAttribute("data-cal-thumb"));
        state.touched = true;
        go(i, i > state.shown ? 1 : -1);
      });
    });
    if (opts.autoFlip && !opts.reducedMotion) {
      setTimeout(function () { if (!state.touched && state.shown === 0) go(1, 1); }, 1500);
    }

    // Drops any turn or drag where it stands and shows the page it was headed for, with nothing moving.
    function halt() {
      gen++;
      swipe = null;
      // getAnimations skips elements under display: none, as in a dialog that has just closed.
      // A finish event already queued this frame still fires after cancel(); land() checks gen for that.
      turning.forEach(function (a) { a.cancel(); });
      turning = [];
      if (root.getAnimations) root.getAnimations({ subtree: true }).forEach(function (a) { a.cancel(); });
      all(stage, ".cal__flip").forEach(function (f) { f.remove(); });
      bottom.style.transform = "";
      bottom.style.transformOrigin = "";
      if (state.anim) {
        fill(top, topContent(state.shown));
        fill(bottom, bottomContent(state.shown));
      }
      state.anim = null;
      state.queued = null;
    }

    function reset() {
      halt();
      if (state.shown !== 0) {
        state.shown = 0;
        fill(top, topContent(0));
        fill(bottom, bottomContent(0));
      }
      setUI(0);
    }

    return {
      go: function (i) { go(i, i > state.shown ? 1 : -1); },
      next: next,
      prev: prev,
      shown: function () { return state.shown; },
      halt: halt,
      reset: reset
    };
  }

  // Below md the calendar shows closed; the cover opens a full-screen <dialog> and the flip's nodes move into it.
  // Opening, the calendar grows out of the cover and its bottom half swings down; closing folds it back onto the cover.
  // The back button closes it too: opening pushes a history entry.
  function createViewer(dialog, opener, home, opts) {
    var body = dialog.querySelector("[data-cal-viewer-body]");
    var closeButtons = all(dialog, "[data-cal-viewer-close]");
    var html = document.documentElement;
    var cal = home.querySelector("[data-cal-flip]");
    var stage = home.querySelector("[data-cal-stage]");
    var top = home.querySelector("[data-cal-top]");
    var bottom = home.querySelector("[data-cal-bottom]");
    var shadow = home.querySelector(".cal__shadow");
    var coverPage = opener.querySelector(".cal-cover__page");
    var chrome = [dialog.firstElementChild, dialog.lastElementChild];
    var animates = !opts.reducedMotion && typeof stage.animate === "function";
    // closed, opening, open or closing
    var phase = "closed";
    var popped = false;
    var touched = false;
    var moves = [];
    var unfold = null;
    // Closing from a month, the cover's own photo fades in over the top half so it lands matching the cover.
    var coverFade = el("div", { class: "cal__page cal__page--top cal__cover-fade", "aria-hidden": "true" }, [coverPage.querySelector(".cal__photo").cloneNode(true)]);

    var GROW = { duration: 380, easing: "cubic-bezier(.2,.7,.3,1)" };
    var UNFOLD = { duration: 350, delay: 380, easing: "cubic-bezier(.3,.6,.4,1)", fill: "backwards" };
    var SHRINK = { duration: 380, easing: "cubic-bezier(.4,0,.2,1)", fill: "forwards" };
    var FOLD = { duration: 200, easing: "ease-in", fill: "forwards" };
    var FADE = { duration: 160, easing: "ease-out", fill: "forwards" };
    // Folded up, the shadow only needs to reach the fold.
    var FOLDED_SHADOW = "scaleY(.48)";

    var hint = null;

    function move(from, to) { while (from.firstChild) to.appendChild(from.firstChild); }

    // Safari paints a fresh or never-shown <img> blank until it decodes, which would flash as the calendar
    // grows out of the cover or lands on it.
    function decode(node) {
      var waits = all(node, "img").map(function (img) { return img.decode ? img.decode().catch(function () {}) : null; });
      return Promise.race([Promise.all(waits), new Promise(function (r) { setTimeout(r, 250); })]);
    }
    decode(top);
    decode(coverFade);

    function showHint() {
      hint = el("div", { class: "cal-swipe-hint", "aria-hidden": "true" });
      hint.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18M7 8l5-5 5 5M7 16l5 5 5-5"/></svg><span>Swipe to browse</span>';
      stage.appendChild(hint);
    }

    function hideHint() {
      if (hint) hint.remove();
      hint = null;
    }

    var autoFlip = null;
    // A touch before the opening flip means the reader is already turning pages themselves.
    function stopAutoFlip() { clearTimeout(autoFlip); autoFlip = null; }

    // The stage transform, from where it rests in the dialog, that lays its top half over the cover button.
    // The stage must be at rest when this measures it.
    function onCover() {
      var from = top.getBoundingClientRect();
      var to = coverPage.getBoundingClientRect();
      var s = coverPage.offsetWidth / top.offsetWidth;
      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);
      // The calendar hangs a little tilted, so the move is worked out along its own tilted axes.
      var tilt = getComputedStyle(cal).transform;
      var m = new DOMMatrix(tilt === "none" ? undefined : tilt);
      var len = Math.hypot(m.a, m.b) || 1;
      var cos = m.a / len;
      var sin = m.b / len;
      var cx = top.offsetLeft + top.offsetWidth / 2;
      var cy = top.offsetTop + top.offsetHeight / 2;
      var x = cos * dx + sin * dy + (1 - s) * cx;
      var y = -sin * dx + cos * dy + (1 - s) * cy;
      return "translate(" + x + "px, " + y + "px) scale(" + s + ")";
    }

    function play(anims, done) {
      moves = anims;
      Promise.all(anims.map(function (a) { return a.finished; })).then(function () {
        if (moves === anims) done();
      }, function () {});
    }

    function stopMoves() {
      moves.forEach(function (a) { a.cancel(); });
      moves = [];
      unfold = null;
    }

    function fadeChrome(from, to, timing) {
      return [dialog.animate([{ backgroundColor: from.bg }, { backgroundColor: to.bg }], timing)]
        .concat(chrome.map(function (c) { return c.animate([{ opacity: from.opacity }, { opacity: to.opacity }], timing); }));
    }

    function open() {
      if (phase !== "closed") return;
      if (opts.flip.shown() !== 0) opts.flip.reset();
      phase = "opening";
      popped = false;
      touched = false;
      move(home, body);
      html.classList.add("cal-viewer-lock");
      opener.setAttribute("data-cal-away", "");
      dialog.showModal();
      closeButtons[0].focus();
      history.pushState({ calViewer: true }, "");
      if (!animates) {
        play(typeof dialog.animate === "function" ? [dialog.animate([{ opacity: 0 }, { opacity: 1 }], FADE)] : [], opened);
        return;
      }
      dialog.setAttribute("data-cal-moving", "");
      unfold = bottom.animate([{ transform: "rotateX(-180deg)" }, { transform: "rotateX(0deg)" }], UNFOLD);
      play([
        stage.animate([{ transform: onCover() }, { transform: "none" }], GROW),
        shadow.animate([{ transform: FOLDED_SHADOW }, { transform: "none" }], UNFOLD),
        unfold
      ].concat(fadeChrome(
        { bg: "transparent", opacity: 0 },
        { bg: getComputedStyle(dialog).backgroundColor, opacity: 1 },
        { duration: GROW.duration, easing: "ease-out" }
      )), opened);
    }

    function opened() {
      stopMoves();
      dialog.removeAttribute("data-cal-moving");
      phase = "open";
      showHint();
      if (!opts.reducedMotion && !touched) {
        autoFlip = setTimeout(function () { if (phase === "open" && opts.flip.shown() === 0) opts.flip.go(1); }, 150);
      }
    }

    function close(fromHistory) {
      if (fromHistory) popped = true;
      if (phase === "closed" || phase === "closing") return;
      phase = "closing";
      stopAutoFlip();
      hideHint();
      if (!animates) {
        var opacity = getComputedStyle(dialog).opacity;
        stopMoves();
        opts.flip.halt();
        play(typeof dialog.animate === "function" ? [dialog.animate([{ opacity: opacity }, { opacity: 0 }], FADE)] : [], function () { settle(popped); });
        return;
      }
      // Closing mid-open starts from wherever the opening got to.
      var progress = unfold ? unfold.effect.getComputedTiming().progress : null;
      var angle = progress === null ? 0 : -180 * (1 - progress);
      var from = {
        stage: getComputedStyle(stage).transform,
        shadow: getComputedStyle(shadow).transform,
        chrome: { bg: getComputedStyle(dialog).backgroundColor, opacity: getComputedStyle(chrome[0]).opacity }
      };
      stopMoves();
      opts.flip.halt();
      dialog.setAttribute("data-cal-moving", "");
      var anims = [
        stage.animate([{ transform: from.stage }, { transform: onCover() }], SHRINK),
        bottom.animate([{ transform: "rotateX(" + angle + "deg)" }, { transform: "rotateX(-180deg)" }], FOLD),
        shadow.animate([{ transform: from.shadow }, { transform: FOLDED_SHADOW }], FOLD)
      ].concat(fadeChrome(from.chrome, { bg: "transparent", opacity: 0 }, SHRINK));
      if (opts.flip.shown() !== 0) {
        stage.appendChild(coverFade);
        anims.push(coverFade.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: 40, easing: "ease-in-out", fill: "both" }));
      }
      var coverReady = decode(coverPage);
      play(anims, function () { coverReady.then(function () { settle(popped); }); });
    }

    var pill = opener.querySelector(".cal-cover__pill");

    function settle(fromHistory) {
      if (phase === "closed") return;
      phase = "closed";
      stopMoves();
      coverFade.remove();
      dialog.removeAttribute("data-cal-moving");
      stopAutoFlip();
      hideHint();
      opts.flip.reset();
      decode(top);
      if (dialog.open) dialog.close();
      move(body, home);
      html.classList.remove("cal-viewer-lock");
      opener.removeAttribute("data-cal-away");
      if (!opts.reducedMotion && pill) {
        pill.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: 80, easing: "ease-out", fill: "backwards" });
      }
      if (!fromHistory && history.state && history.state.calViewer) history.back();
      opener.focus();
    }

    // Before open, so the cover is back at rest when open measures it.
    opener.addEventListener("click", function () { opener.setAttribute("data-cal-opened", ""); });
    opener.addEventListener("click", open);
    body.addEventListener("pointerdown", function () { touched = true; hideHint(); stopAutoFlip(); });
    dialog.addEventListener("keydown", hideHint);
    closeButtons.forEach(function (b) { b.addEventListener("click", function () { close(false); }); });
    dialog.addEventListener("cancel", function (e) { e.preventDefault(); close(false); });
    // Chrome skips cancel on a repeated Escape and closes the dialog outright.
    dialog.addEventListener("close", function () { settle(popped); });
    window.addEventListener("popstate", function () { close(true); });
    opts.desktop.addEventListener("change", function (e) { if (e.matches) settle(popped); });

    return {
      isOpen: function () { return phase !== "closed"; },
      busy: function () { return phase === "opening" || phase === "closing"; },
      close: function () { close(false); }
    };
  }


  var data = readPageData();
  if (!data) return;
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var flap = createFlaps(reducedMotion);
  var store = createStore(data, initialState(Date.now(), data.inCart === true, Number(data.cartCount) || 0), function (s) {
    render(document, data, s, flap);
  });

  var desktop = window.matchMedia("(min-width: 768px)");
  var viewer = null;

  render(document, data, store.get());
  bindForms(document, store, data);
  watchCart(store, data);
  startClock(store);

  var flipRoot = document.querySelector("[data-cal-flip]");
  if (!flipRoot) return;
  var flip = createFlip(flipRoot, data, {
    reducedMotion: reducedMotion,
    autoFlip: desktop.matches,
    viewing: function () { return viewer ? viewer.isOpen() : false; },
    busy: function () { return viewer ? viewer.busy() : false; },
    onCoverSwipeDown: function () { viewer.close(); }
  });

  var dialog = document.querySelector("[data-cal-viewer]");
  var opener = document.querySelector("[data-cal-viewer-open]");
  var home = document.querySelector("[data-cal-flip-home]");
  if (dialog && opener && home && typeof dialog.showModal === "function") {
    viewer = createViewer(dialog, opener, home, { flip: flip, reducedMotion: reducedMotion, desktop: desktop });
  }
})();
